/**
 * @generated SignedSource<<37909694f13cbaec76c1974775ccbc0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "associationId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "associationType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "messageId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "associationId",
    "variableName": "associationId"
  },
  {
    "kind": "Variable",
    "name": "associationType",
    "variableName": "associationType"
  },
  {
    "kind": "Variable",
    "name": "messageId",
    "variableName": "messageId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sender",
  "storageKey": null
},
v7 = {
  "alias": "conversation",
  "args": null,
  "concreteType": "Conversation",
  "kind": "LinkedField",
  "name": "conversationByConversationId",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyExcerpt",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pictureUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v15 = [
  (v4/*: any*/),
  (v10/*: any*/)
],
v16 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 666
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "apiMarkMessagesAsReadWithFetchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "markMessageAsRead",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MessageRow_message"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "apiMarkMessagesAsReadWithFetchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "markMessageAsRead",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": "user",
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "userByUserId",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "family",
            "args": null,
            "concreteType": "Family",
            "kind": "LinkedField",
            "name": "familyByFamilyId",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": "contact",
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contactByContactId",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "partner",
            "args": null,
            "concreteType": "Partner",
            "kind": "LinkedField",
            "name": "partnerByPartnerId",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": "parts",
            "args": (v16/*: any*/),
            "concreteType": "PartsConnection",
            "kind": "LinkedField",
            "name": "partsByMessageId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PartsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Part",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "order",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mimeType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "body",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedBody",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "content",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "partsByMessageId(first:666)"
          },
          {
            "alias": "parts",
            "args": (v16/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "Messages_parts",
            "kind": "LinkedHandle",
            "name": "partsByMessageId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "173841eb5b66dcb7b6ded57d23ee1ba7",
    "id": null,
    "metadata": {},
    "name": "apiMarkMessagesAsReadWithFetchMutation",
    "operationKind": "mutation",
    "text": "mutation apiMarkMessagesAsReadWithFetchMutation(\n  $messageId: Uuid!\n  $associationId: Uuid\n  $associationType: ParticipantAssociationType\n) {\n  markMessageAsRead(messageId: $messageId, associationId: $associationId, associationType: $associationType) {\n    id\n    createdAt\n    sender\n    conversation: conversationByConversationId {\n      id\n    }\n    ...MessageRow_message\n  }\n}\n\nfragment MessageRow_message on Message {\n  id\n  userId\n  bodyExcerpt\n  createdAt\n  sender\n  user: userByUserId {\n    id\n    pictureUrl\n    name\n    firstName\n    lastName\n    email\n    phone\n  }\n  family: familyByFamilyId {\n    id\n    name\n  }\n  contact: contactByContactId {\n    id\n    pictureUrl\n    firstName\n    lastName\n    email\n    phone\n  }\n  partner: partnerByPartnerId {\n    id\n    name\n  }\n  parts: partsByMessageId(first: 666) {\n    edges {\n      node {\n        id\n        order\n        mimeType\n        body\n        bodyExcerpt\n        formattedBody\n        contentUrl\n        content\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

node.hash = "5e7389547bd3dfbeb9ebbd665d0fde7c";

module.exports = node;
